import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Header from '../menu/header2'; // Make sure you have a header component

import Pic1 from '../../../src/assets/tl1.png';
import Pic2 from '../../../src/assets/tl2.png';
// The video components are commented out in the original,
// so they are omitted here. If needed, you can uncomment and include them.

const TheLot = () => {
  return (
    <>
      {/* Header is rendered outside the main container */}
      <Header />

      {/* Main container with top padding to push content below the fixed header */}
      <Container
        fluid
        style={{
          backgroundColor: '#ffffff',
          padding: '20px',
          paddingTop: '100px' // Adjust this value to match your header's height
        }}
      >
        <Row>
          {/* Left Column: Images */}
          <Col md={7}>
            <img
              src={Pic1}
              alt="DAO"
              style={{ width: '100%', height: 'auto', paddingBottom: '2em' }}
            />
            <img
              src={Pic2}
              alt="DAO"
              style={{ width: '100%', height: 'auto', paddingBottom: '2em' }}
            />
            {/* Additional rows or videos can be added here if needed */}
          </Col>

          {/* Right Column: Textual Content */}
          <Col md={5} style={{ color: 'black' }}>
            <h1>DAO Management dapp - Work in Progress</h1>
            <p>
              We are working on an innovative social media platform that incorporates DAO management tools.
            </p>
            <h3>Key Features</h3>
            <ul>
              <li>Proposal System</li>
              <li>Web2-like social media interactions</li>
              <li>Integration with existing DAO tools</li>
            </ul>

            <br />

            {/* Two Rows with Two Columns Each */}
            <Row className="mb-3">
              <Col xs={6}>
                <h3>MVP Completion Date</h3>
                <p>WIP</p>
              </Col>
              <Col xs={6}>
                
              </Col>
            </Row>

            <Row>
              <Col xs={6}>
                <h3>Skills Used</h3>
                <p>
                  Smart Contract development, Website development, Branding, Brand Strategy, Tokenomics, Finance, 3D Content Design, Mongo
                </p>
              </Col>
              <Col xs={6}>
                <h3>Technology Used</h3>
                <p>
                  Solidity for Smart Contracts, React, Adobe Creative Cloud, Centralized server
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default TheLot;
